var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66699 10.6161C2.66699 10.2428 2.96497 9.94014 3.33255 9.94014C3.70013 9.94014 3.99811 10.2428 3.99811 10.6161V11.9813L12.0025 11.9813V10.6161C12.0025 10.2428 12.3005 9.94014 12.6681 9.94014C13.0357 9.94014 13.3337 10.2428 13.3337 10.6161V11.9813C13.3337 12.728 12.7377 13.3333 12.0025 13.3333H3.99811C3.26295 13.3333 2.66699 12.728 2.66699 11.9813V10.6161ZM5.78388 7.09887L7.30994 8.64888L7.30994 3.34265C7.30994 2.96931 7.60792 2.66665 7.97549 2.66665C8.34307 2.66665 8.64105 2.96931 8.64105 3.34265L8.64105 8.64887L10.1671 7.09887C10.427 6.83487 10.8484 6.83487 11.1083 7.09887C11.3683 7.36286 11.3683 7.79089 11.1083 8.05488L8.91673 10.2809C8.3969 10.8089 7.55408 10.8089 7.03425 10.2809L4.84264 8.05488C4.58272 7.79089 4.58272 7.36286 4.84264 7.09887C5.10256 6.83487 5.52396 6.83487 5.78388 7.09887Z",
    fill: "#28245C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDark);
export default __webpack_public_path__ + "static/media/download-dark.fea3f08745e53543afe86c9c8508ae8a.svg";
export { ForwardRef as ReactComponent };